import ReactModal from '@/components/modal';
import React, { useState, useRef, useEffect } from 'react';
import './index.less';
import { Modal } from 'antd';
import { formateTimeStamp } from '@/common/utils';

const NoticePopup = (props) => {
  const { noticePopList } = props;
  const [isModalVisible, setModalVisible] = useState(true);
  const [popDataNow, setPopDataNow] = useState(noticePopList[0]);
  const [popIndex, setPopIndex] = useState(0);
  const noticeContentRef = useRef(null);

  useEffect(() => {
    if (noticePopList[0].type === 2) {
      noticeContentRef.current.innerHTML = noticePopList[0].content;
    }
  }, [noticePopList]);

  function renderNextPopup(btnUrl) {
    if (btnUrl) {
      window.open(btnUrl);
    }
    setModalVisible(false);
    if (popIndex + 1 <= noticePopList.length - 1) {
      setPopDataNow(noticePopList[popIndex + 1]);
      setPopIndex(popIndex + 1);
      setTimeout(() => {
        setModalVisible(true);
        if (noticePopList[popIndex + 1].type === 2) {
          noticeContentRef.current.innerHTML = noticePopList[popIndex + 1].content;
        }
      }, 1000);
    }
  }

  return (
    <ReactModal>
      {popDataNow.type === 1 ? (
        <Modal
          title={<span style={{ fontSize: '20px' }}>{popDataNow.title}</span>}
          visible={isModalVisible}
          width="840px"
          onCancel={() => renderNextPopup()}
          style={{ maxHeight: '700px' }}
          onOk={() => renderNextPopup(popDataNow.btnUrl)}
          okText={popDataNow.btn}
          cancelButtonProps={{ style: { display: 'none' } }}
          okButtonProps={{ type: 'primary', shape: 'round' }}
          className="notice-pop-wrap"
        >
          <div className="notice-img-wrap">
            <img className="notice-img" src={popDataNow.imgUrl} />
          </div>
        </Modal>
      ) : (
        <Modal
          title={<span style={{ fontSize: '20px' }}>{popDataNow.title}</span>}
          visible={isModalVisible}
          width="840px"
          style={{ maxHeight: '700px' }}
          onCancel={() => renderNextPopup()}
          onOk={() => renderNextPopup()}
          okText="我知道了"
          okButtonProps={{ type: 'primary', ghost: true, shape: 'round' }}
          cancelButtonProps={{ style: { display: 'none' } }}
          className="notice-pop-wrap"
        >
          <div className="notice-pop">
            <div className="time">{formateTimeStamp(popDataNow.createTime, true)}</div>
            <div ref={noticeContentRef} className="content" />
          </div>
        </Modal>
      )}
    </ReactModal>
  );
};

export default NoticePopup;
